<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs [(ttSelectedId)]="selectedBgPickJobGroupBatchesPicker">
                <tt-tab ttId="JOBS" ttLabel="bg_pickjobgrpbatchespicker_jobs"></tt-tab>
                <tt-tab ttId="OTHER" ttLabel="bg_pickjobgrpbatchespicker_other"></tt-tab>
            </tt-tabs>

            <div *ngIf="selectedBgPickJobGroupBatchesPicker === 'OTHER'">
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </div>
        </tt-card>

        <tt-list *ngIf="selectedBgPickJobGroupBatchesPicker === 'JOBS'" [ttData]="itemsListPickers"></tt-list>
    </div>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 col-md-4 p-5">
            <tt-card ttHeading="bg_pickjobgrpbatchespicker_jobs"></tt-card>
            <tt-list [ttData]="itemsListPickers"></tt-list>
        </div>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="bg_pickjobgrpbatchespicker_other">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-select ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-select ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" [ttData]="selectListStockPlaces" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-input ttLabel="my_nbr_of_picks_last_hour" [ttModel]="setting.my_nbr_of_picks_last_hour" ttReadonly></tt-input>
        <tt-input ttLabel="my_nbr_of_picks_today" [ttModel]="setting.my_nbr_of_picks_today" ttReadonly></tt-input>
        <tt-input ttLabel="my_nbr_of_picks_yesterday" [ttModel]="setting.my_nbr_of_picks_yesterday" ttReadonly></tt-input>
    </ng-container>
</ng-template>
